import React, { createContext, useContext, useState, useEffect } from 'react'
import { trackConciergeViewedorDismissed } from '../events'
import {
  isConciergeExperienceAlreadyViewed,
  setConciergeExperienceViewed,
} from '../helpers'

type View = 'explainer' | 'content'

interface FabContext {
  toggleConcierge: (track?: boolean) => void
  isOpened: boolean
  showFab: boolean
  setShowFab: (showFab: boolean) => void
  changeView: (view: View) => void
  view: View
}

export const FabContext = createContext<FabContext>({
  toggleConcierge: () => {},
  setShowFab: () => {},
  showFab: true,
  isOpened: true,
  changeView: () => {},
  view: 'content',
})

export const FabProvider = ({ children }: { children: React.ReactNode }) => {
  const [isOpened, setIsOpened] = useState(
    !isConciergeExperienceAlreadyViewed(),
  )
  const [showFab, setShowFab] = useState(true)
  const [view, setView] = useState<View>('content')

  useEffect(() => {
    setConciergeExperienceViewed()
    trackConciergeViewedorDismissed({
      show: true,
      manuallyDismissed: false,
    })
  }, [])

  const toggleConcierge = (track: boolean = true) => {
    setIsOpened((prev) => {
      if (track) {
        trackConciergeViewedorDismissed({
          show: !prev,
          manuallyDismissed: true,
        })
      }
      return !prev
    })
  }

  const handleShowFab = (show: boolean) => {
    setShowFab(show)
  }

  return (
    <FabContext.Provider
      value={{
        toggleConcierge,
        showFab,
        setShowFab: handleShowFab,
        isOpened,
        changeView: setView,
        view,
      }}
    >
      {children}
    </FabContext.Provider>
  )
}

export const useFab = () => {
  const context = useContext(FabContext)

  if (!context) {
    throw new Error('useFab must be used within a FabProvider')
  }

  return context
}
